import styled from 'styled-components'

const StyledQCTable = styled.table`
  width: 100%;
  border-spacing: 0.5rem 1rem;
  @media (max-width: 48rem) {
    border-spacing: 0.12rem 0.18rem;
    margin: 0.12rem 0rem;
  }
`

const StyledAddMoreButton = styled.div`
  padding: 0.25rem 0.5rem;
  font-weight: bold;
  float: right;
  margin: 0.12rem 0;
  cursor: pointer;
  border: 0.06rem solid black;
  font-size: 0.87rem;
  @media (max-width: 48rem) {
    padding: 0.12rem 0.25rem;
    font-size: 0.5rem;
    margin: 0.25rem 0rem;
  }
`

const StyledRowHeading = styled.th`
  padding: 0.5rem 0.25rem;
  font-size: 1rem;
  @media (max-width: 48rem) {
    padding: 0.25rem 0.12rem;
    font-size: 0.5rem;
  }
`

const StyledRowColumn = styled.td`
  margin: 0.5rem;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
  word-wrap: break-word;
  overflow: hidden;
  height: auto;
  @media (max-width: 48rem) {
    padding: 0.12rem 0.12rem;
    max-width: 8.12rem;
    font-size: 0.5rem;
  }
`

const StyledTextAreaField = styled.textarea`
  width: 100%;
  min-width: 6.25rem;
  text-align: center;
  height: 3rem;
  min-height: 3rem;
  border: none;
  padding: 0.5rem;
  background-color: var(--grey-300);
  outline: 0;
  border-radius: 0.25rem;
  font-size: 1rem;
  line-height: 1.5;
  color: var(--Text700);
  cursor: pointer;
  @media (max-width: 48rem) {
    padding: 0.12rem 0.12rem;
    max-width: 10.625rem;
    font-size: 0.5rem;
  }
`

const StyledInputField = styled.input`
  width: 3.12rem;
  text-align: center;
  height: 3rem;
  border: none;
  padding: 0.37rem;
  background-color: var(--grey-300);
  outline: 0;
  border-radius: 0.25rem;
  font-size: 0.87rem;
  line-height: 1.5;
  color: var(--Text700);
  cursor: pointer;
  @media (max-width: 48rem) {
    padding: 0.12rem 0.12rem;
    max-width: 8.12rem;
    font-size: 0.5rem;
  }
`
const StyledSelectField = styled.select`
  width: ${({ width }) => (width ? `${width}rem` : '4.37rem')};
  height: 3rem;
  border: none;
  padding: 0.37rem;
  background-color: var(--grey-300);
  outline: 0;
  border-radius: 0.25rem;
  font-size: 0.87rem;
  line-height: 1.5;
  color: var(--Text700);
  cursor: pointer;
  @media (max-width: 48rem) {
    width: ${({ width }) => (width ? `${width - 1.56}rem` : '4.37rem')};
    min-width: 2.25rem;
    font-size: 0.5rem;
    height: 2.25rem;
    padding: 0.25rem;
  }
`

export {
  StyledQCTable,
  StyledAddMoreButton,
  StyledTextAreaField,
  StyledInputField,
  StyledSelectField,
  StyledRowColumn,
  StyledRowHeading,
}
